import { render } from "./Avatar_logo.vue?vue&type=template&id=648ac968&scoped=true"
import script from "./Avatar_logo.vue?vue&type=script&lang=js"
export * from "./Avatar_logo.vue?vue&type=script&lang=js"

import "./Avatar_logo.vue?vue&type=style&index=0&id=648ac968&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648ac968"]])

export default __exports__